import React from "react";
import FeatureGrid from "./FeatureGrid";

const OtherFeaturesSection = ({ features }) => {
  return (
    <div className="lg:pb-[52px] md:pb-7 pb-4 lg:mb-[52px] md:mb-7 mb-4 border-b border-[#E7EDF4] ">
      {features?.map((item) => (
        <div
          key={`detail-feature-${item.id}`}
          className="flex sm:flex-row flex-col rounded-xl bg-headerbgColor lg:py-[30px] py-5 lg:px-6 px-3 sm:gap-0 gap-2 mb-2"
        >
          <div className="w-full sm:w-1/5">
            <span className="text-base font-bold leading-normal text-themeBlack">
              {item?.baslik}
            </span>
          </div>
          <div className="w-full sm:w-4/5">
            <FeatureGrid features={item.sub} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default OtherFeaturesSection;
